define.alias("shared/components/shared/ui/search-box/result", "media/components/shared/ui/search-box/result");